<template>
  <div class="app-alertImport" v-if="items?.importInfo?.length">
    <div class="app-alertImport__items">
      <div class="app-alertImport__titleblock">
        <div class="app-alertImport__titleblock__title">
          Импорт данных
        </div>
        <div class="app-alertImport__titleblock__collapsebtn" @click="toggleCollapse" title="Свернуть">
          <div class="app-alertImport__titleblock__collapsebtn_btn"></div>
        </div>
      </div>
      <div
          v-if="!isCollapsed"
          v-for="item in items?.importInfo"
          :key="item.index"
          class="app-alertImport__item"
      >
        <close-icon
            class="app-alertImport__item__close"
            @click="store.commit('removeImportInfo', item)"
            color="#fff"
        />
        <div class="mr-2" style="width: 80px">
          <app-progress-circle
              :min="0"
              :max="totalCount(item)"
              :value="processedCount(item)"
          />
        </div>
        <div class='app-alertImport__item__content'>
          <div class='app-alertImport__item__content_title'>
            {{ titleProcess(item?.type_job) }}
          </div>
          <div class='app-alertImport__item__content_status'>
            Обработано {{ processedCount(item) }} из {{ totalCount(item) }}
          </div>
          <div class='app-alertImport__item__content_errors mt-1' v-if="item?.status_job_2 !== 0 || item?.status_job_4 !== 0">
            <a @click="openImportLogs(item)">Есть ошибки/комментарии</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex'
import { computed, watch, ref } from 'vue'
import AppProgressCircle from "@/components/UI/AppProgressCircle.vue";
import CloseIcon from "@/components/UI/mtSvg/svg/CloseIcon.vue";
import { useRouter } from 'vue-router';

const store = useStore()
const items = computed(() => store.state.importInfo)
const isCollapsed = ref(false);
const router = useRouter();


function processedCount(item = null) {
  if (!item) return 0
  return (item.status_job_1 + item.status_job_2 + item.status_job_3 + item.status_job_4) || 0
}
function totalCount(item = null) {
  if (!item) return 0
  return (item.status_job_0 + item.status_job_1 + item.status_job_2 + item.status_job_3 + item.status_job_4) || 0
}

function titleProcess(type_job = null) {
  if (!type_job) return ''

  switch (type_job) {
    case 'users':
      return 'Импорт пользователей'
    default:
      return ''
  }
}

function toggleCollapse() {
  isCollapsed.value = !isCollapsed.value;
}

function openImportLogs(item) {
  router.push({
    name: "LogImport",
    params: {
      type: 'users'
    },
    query: {
      page: 1,
      filters: JSON.stringify([
        {field: "process_code", title: "Код процесса", type: "string", value: item?.process_code},
        {field: "status_job", title: "Статус задачи", type: "list", value: [2,4], list: ["Ошибка","Обработан с комментарием"]}
      ])
    },
  });
}

watch(items, (newItems) => {
  newItems?.importInfo.forEach(item => {
    const progress = processedCount(item) / totalCount(item)
    if (progress >= 1) {
      setTimeout(() => {
        if (item?.status_job_2 === 0) {
          store.commit('removeImportInfo', item)
        }
      }, 5000)
    }
  })
}, { deep: true })
</script>

<style lang="scss" src="./AppAlertImport.scss" />